<template>
<div style="height: 100%;" id="app-container">
  <div v-if="dragOver" class="dropzone" @drop="handleDrop" @dragexit="dragOver = false" @dragend="dragOver = false" @dragleave="dragOver = false">
    <v-icon x-large color="white">cloud_upload</v-icon>
  </div>
  <v-app :dark="dark" :class="theme ? 'logbook-theme-' + theme.toLowerCase() : ''">
    <v-navigation-drawer
      v-model="drawer"
      fixed
      app
    >
    <v-toolbar flat>
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title">
            Settings
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-toolbar>

    <v-divider></v-divider>

    <v-list dense class="pt-0">
      <v-list-group>
        <template v-slot:activator>
          <v-list-tile>
          <v-list-tile-content>
          <v-list-tile-title>Design</v-list-tile-title>
          </v-list-tile-content>
          </v-list-tile>
        </template>
        <v-list-tile>
          <v-switch
            :input-value="dark"
            @change="setDarkMode"
            label="Dark Mode"
            value
            :true-value="true"
            :false-value="false"
          ></v-switch>
        </v-list-tile>
          <v-select
            :value="theme"
            :items="themes"
            label="Theme"
            @change="setTheme"
            hint="Select a theme for your LogBook"
            persistant-hint
            style="margin: 0 10px 10px 10px;"
          />
      </v-list-group>
      <v-list-group :value="true">
        <template v-slot:activator>
          <v-list-tile>
          <v-list-tile-content>
          <v-list-tile-title>Features</v-list-tile-title>
          </v-list-tile-content>
          </v-list-tile>
        </template>
        <v-list-tile>
          <v-switch
            :input-value="displayTags"
            @change="setDisplayTags"
            label="Display Tags"
            value
            :true-value="true"
            :false-value="false"
          ></v-switch>
        </v-list-tile>
        <v-list-tile>
          <v-switch
            :input-value="displayRatings"
            @change="setDisplayRatings"
            label="Display Ratings"
            value
            :true-value="true"
            :false-value="false"
          ></v-switch>
        </v-list-tile>
        <v-list-tile>
          <v-switch
            :input-value="displayTimers"
            @change="setDisplayTimers"
            label="Display Timers"
            value
            :true-value="true"
            :false-value="false"
          ></v-switch>
        </v-list-tile>
        <v-list-tile>
          <v-switch
            :input-value="displayUpcomingBox"
            @change="setDisplayUpcomingBox"
            label="Display Upcoming Tasks Box"
            value
            :true-value="true"
            :false-value="false"
          ></v-switch>
        </v-list-tile>
        <v-list-tile>
          <v-switch
            :input-value="displayNotes"
            @change="setDisplayNotes"
            label="Display notes"
            value
            :true-value="true"
            :false-value="false"
          ></v-switch>
        </v-list-tile>
        <v-list-tile>
          <v-switch
            :input-value="sparklineMode"
            @change="setSparklineMode"
            label="Sparklines use bars"
            value
            true-value="bars"
            false-value="trend"
          ></v-switch>
        </v-list-tile>
        <v-list-tile>
          <v-switch
            :input-value="fillSparklines"
            @change="setFillSparklines"
            label="Fill Sparklines"
            value
            :true-value="true"
            :false-value="false"
          ></v-switch>
        </v-list-tile>
        <v-list-tile>
          <v-switch
            :input-value="alwaysDisplayTaskTools"
            @change="setAlwaysDisplayTaskTools"
            label="Always display task tools"
            value
            :true-value="true"
            :false-value="false"
          ></v-switch>
        </v-list-tile>
        <v-list-tile>
          <v-switch
            :input-value="useGeolocation"
            @change="setUseGeolocation"
            label="Use Geolocation"
            value
            :true-value="true"
            :false-value="false"
          ></v-switch>
        </v-list-tile>
        <v-list-tile>
          <v-switch
            :input-value="displayGeolocation"
            @change="setDisplayGeolocation"
            label="Display Geolocation if available"
            value
            :true-value="true"
            :false-value="false"
          ></v-switch>
        </v-list-tile>
        <v-list-tile>
          <v-switch
            :input-value="togglIntegrationActive"
            @change="configureToggl"
            label="Toggl Integration"
            value
            :true-value="true"
            :false-value="false"
          ></v-switch>
          <v-icon v-if="togglIntegrationActive" @click="configureToggl(true)">settings</v-icon>
        </v-list-tile>
      </v-list-group>
    </v-list>

    <v-toolbar flat>
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title">
          Data
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-toolbar>
      <v-divider />

    <v-list>
      <v-list-tile @click="downloadData">
        <v-list-tile-action>
          <v-icon>save_alt</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Download Data</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="clearData">
        <v-list-tile-action>
          <v-icon>delete</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Clear Data</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="clickUploadButton">
        <v-list-tile-action>
          <v-icon>attachment</v-icon>
        </v-list-tile-action>
          <v-list-tile-title>Load Data</v-list-tile-title>
            <upload-btn ref="uploadBtn" @file-update="handleUpload" noTitleUpdate style="display: none;"></upload-btn>
      </v-list-tile>
    </v-list>

    <v-toolbar flat>
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title">
          Hints
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-toolbar>
    <v-divider />

    <div class="keybinds">
      <div>
        <kbd>SHIFT + ENTER</kbd> to add children
      </div>
      <div>
        <kbd>CTRL + ENTER</kbd> to add siblings
      </div>
      <div>
        <kbd>ALT + ENTER</kbd> to add root elements
    </div>
    <p>You can use markdown to format your entries</p>
  </div>

  </v-navigation-drawer>

    <v-toolbar app>
      <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title class="headline text-uppercase">
        <span>LogBook</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="lastMood" class="title text-uppercase">
        <v-layout row align-center>
          <v-flex align-baseline >
            <v-icon>favorite</v-icon>
            <span>// {{ lastMood.text }}</span>
            <span class="font-weight-light hidden-sm-and-down"> {{ lastMood.timestamp | fromNow }}</span>
          </v-flex>
        </v-layout>
      </v-toolbar-items>
    </v-toolbar>

    <v-content fluid>
        <router-view/>
    </v-content>
    <v-layout wrap>
  </v-layout>
    <v-snackbar
      v-model="displaySnackbar"
    >
      {{ snackbar }}
      <v-btn
        dark
        flat
        @click="displaySnackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <div class="floating-image" />
      <TheTogglConfigurator
      :show="togglConfig"
      @done="finishTogglConfig"
      @cancel="finishTogglConfig"
    />
  </v-app>
</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';
import UploadButton from 'vuetify-upload-button';
import merge from 'deepmerge';
import TheTogglConfigurator from '@/components/TheTogglConfigurator.vue';

export default {
  name: 'App',
  components: {
    'upload-btn': UploadButton,
    TheTogglConfigurator
  },
  data () {
    return {
      drawer: false,
      displaySnackbar: false,
      snackbar: '',
      dragOver: false,
      togglConfig: false,
      themes: [ 'Alpine', 'Breezy', 'Rustic', 'Rainy', 'Snowy', 'Default', 'Urban', 'Space' ]
    }
  },
  computed: {
    geo() {
      return this.useGeolocation;
    },
    ...mapGetters([
      "dark",
      "theme",
      "displayRatings",
      "displayTags",
      "sparklineMode",
      "lastMood",
      "fillSparklines",
      "logs",
      "moodLog",
      "notes",
      "alwaysDisplayTaskTools",
      "displayTimers",
      "displayUpcomingBox",
      "useGeolocation",
      "displayGeolocation",
      "displayNotes",
      "togglIntegrationActive",
      "togglApiKey",
      "togglWorkspaceId"
    ])
  },
  mounted() {
    let vm = this;
    window.addEventListener('dragenter', vm.handleDragOver);
  },
  filters: {
    fromNow(value) {
      return moment(value).fromNow();
    }
  },
  methods: {
    updateDarkMode(value) {
    },
    downloadData() {
      let data = {
        logs: this.logs,
        moodLog: this.moodLog,
        notes: this.notes
      };

      let blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
      if (window.navigator.msSaveOrOpenBlob) { // IE10+
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else { // Others
        var a = document.createElement("a"),
          url = URL.createObjectURL(blob);
        a.href = url;
        let ts = new Date().toISOString();
        a.download = 'logbook-data-' + ts + '.json';
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);  
        }, 0); 
        this.snackbar = 'Download started';
        this.displaySnackbar = true;
      }
    },
    clearData() {
      if (confirm('Are you sure you want to clear your data? Make sure you have downloaded your data so you can import it later')) {
        this.setLogs({});
        this.setMoodlog([]);
        this.clearNotes();
        this.snackbar = 'Your data has been cleared';
        this.displaySnackbar = true;
      }
    },
    handleUpload(file) {
      let reader = new FileReader();
      reader.onload = (e) => { 
        let json = JSON.parse(e.target.result);
        if (json.hasOwnProperty('logs')) {
          let result = {};
          for (let key in json.logs) {

            let dupes = [];
            let curList = (this.logs.hasOwnProperty(key)) ? this.logs[key] : [];
            if (this.logs.hasOwnProperty(key)) {
              dupes = curList.map(item => item.id);
            }

            let filtered = json.logs[key].filter(item => !dupes.includes(item.id));

            result[key] = merge(curList, filtered);
          }
          this.setLogs(result);
        }
        if (json.hasOwnProperty('moodLog')) {
          let dupes = this.moodLog.map(item => item.timestamp);
          let filtered = json.moodLog.filter(item => !dupes.includes(item.timestamp));
          let moodLog = merge(this.moodLog, filtered);
          this.setMoodlog(moodLog);
        }
        if (json.hasOwnProperty('notes')) {
          this.setNotes(json.notes);
        }
        this.snackbar = 'File loaded';
        this.displaySnackbar = true;
      };
      reader.readAsText(file);
    },
    clickUploadButton() {
      if (confirm('Warning: Loading Data merges your files with your existing data. Are you sure?')) {
        this.$refs.uploadBtn.$el.firstChild.click();
      }
    },
    handleDrop(e) {
      this.dragOver = false;
      e.stopPropagation();
      e.preventDefault();
      if (e.dataTransfer.files.length > 0) {
        if (e.dataTransfer.files[0].type === 'application/json') {
          if (confirm('Warning: Loading Data merges your files with your existing data. Are you sure?')) {
            this.handleUpload(e.dataTransfer.files[0]);
          }
        }
      }
    },
    handleDragOver(e) {
      e.preventDefault();
      if (e.dataTransfer.items.length > 0 && e.dataTransfer.items[0].type == 'application/json') {
        if (this.dragOver) return;
        this.dragOver = true;
      }
    },
    handleDragEnd(e) {
      if (this.dragOver) this.dragOver = false;
    },
    configureToggl(e) {
      if (!e) {
        this.setTogglIntegrationActive(e);
        this.setTogglApiKey(null);
        this.setTogglWorkspaceId(null);
      }
      this.togglConfig = e;
    },
    finishTogglConfig() {
      if (!this.togglApiKey || !this.togglWorkspaceId) {
        this.setTogglApiKey(null);
        this.setTogglWorkspaceId(null);
        this.setTogglIntegrationActive(false);
      }
      this.togglConfig = false;
    },
    ...mapActions([
      "setDisplayTags",
      "setDisplayRatings",
      "setDisplayTimers",
      "setDarkMode",
      "setSparklineMode",
      "setFillSparklines",
      "setLogs",
      "setMoodlog",
      "clearNotes",
      "setAlwaysDisplayTaskTools",
      "setDisplayUpcomingBox",
      "setUseGeolocation",
      "setDisplayGeolocation",
      "setDisplayNotes",
      "setTheme",
      "setNotes",
      "setTogglIntegrationActive",
      "setTogglWorkspaceId",
      "setTogglApiKey"
    ])
  }
}
</script>

<style lang="scss" scoped>
.dragging {
  background: red;
}

.dropzone {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.8);
}

.keybinds {
  padding: 10px;
}

.floating-image {
  display: none;
}

.application {
  &.logbook-theme-rustic {
    background-attachment: fixed !important;

    /*.floating-image {*/
      /*display: block;*/
      /*position: fixed;*/
      /*z-index: 0;*/
      /*right: 0;*/
      /*bottom: 0;*/
      /*opacity: 0.5;*/
      /*background: url('./assets/themes/rustic/floating.png');*/
      /*background-position-x: right;*/
      /*background-position-y: bottom;*/
      /*background-repeat: no-repeat;*/
      /*background-size: contain;*/
      /*width: 25%;*/
      /*height: 50%;*/
    /*}*/

    &.theme--dark {
      background: url('./assets/themes/rustic/bg-dark.jpg');
      ::v-deep .theme--dark.v-sheet {
        background: #424242a0;
        .theme--dark.v-sheet {
          background: #424242a0 !important;
        }

        .mood-select {
          .v-input__slot {
            background: #42424269 !important;
          }
        }

        pre {
          background: #0000004f;

          code {
            box-shadow: none;
          }
        }
      }
    }
    &.theme--light {
      background: url('./assets/themes/rustic/bg-light.jpg');
      ::v-deep .theme--light.v-sheet {
        background: #ffffffd9;
        .theme--light.v-sheet {
          background: #ffffffd9 !important;
        }

        .mood-select {
          .v-input__slot {
            background: #ffffffc4 !important;
          }
        }

        pre {
          background: #000000b5;

          code {
            box-shadow: none;
          }
        }
      }
    }
  }

  &.logbook-theme-breezy {
    background-attachment: fixed !important;
    background-size: cover !important;
    background-position: center !important;

    &.theme--dark {
      background: url('./assets/themes/breezy/bg-dark.jpg');
      ::v-deep .theme--dark.v-sheet {
        background: #424242a0;
        .theme--dark.v-sheet {
          background: #424242c4 !important;
        }

        .mood-select {
          .v-input__slot {
            background: #42424269 !important;
          }
        }

        pre {
          background: #0000004f;

          code {
            box-shadow: none;
          }
        }
      }
    }
    &.theme--light {
      background: url('./assets/themes/breezy/bg-light.jpg');
      ::v-deep .theme--light.v-sheet {
        background: #ffffffd9;
        .theme--light.v-sheet {
          background: #ffffffd9 !important;
        }

        .mood-select {
          .v-input__slot {
            background: #ffffffc4 !important;
          }
        }

        pre {
          background: #000000b5;

          code {
            box-shadow: none;
          }
        }
      }
    }
  }

  &.logbook-theme-rainy {
    background-attachment: fixed !important;
    background-size: cover !important;
    background-position: center !important;

    &.theme--dark {
      background: url('./assets/themes/rainy/bg-dark.jpg');
      ::v-deep .theme--dark.v-sheet {
        background: #424242bd;
        .theme--dark.v-sheet {
          background: #424242c4 !important;
        }

        .mood-select {
          .v-input__slot {
            background: #42424269 !important;
          }
        }

        pre {
          background: #0000004f;

          code {
            box-shadow: none;
          }
        }
      }
    }
    &.theme--light {
      background: url('./assets/themes/rainy/bg-light.jpg');
      ::v-deep .theme--light.v-sheet {
        background: #ffffffd9;
        .theme--light.v-sheet {
          background: #ffffffd9 !important;
        }

        .mood-select {
          .v-input__slot {
            background: #ffffffc4 !important;
          }
        }

        pre {
          background: #000000b5;

          code {
            box-shadow: none;
          }
        }
      }
    }
  }

  &.logbook-theme-snowy {
    background-attachment: fixed !important;
    background-size: cover !important;
    background-position: center !important;

    &.theme--dark {
      background: url('./assets/themes/snowy/bg-dark.jpg');
      ::v-deep .theme--dark.v-sheet {
        background: #424242bd;
        .theme--dark.v-sheet {
          background: #424242c4 !important;
        }

        .mood-select {
          .v-input__slot {
            background: #42424269 !important;
          }
        }

        pre {
          background: #0000004f;

          code {
            box-shadow: none;
          }
        }
      }
    }
    &.theme--light {
      background: url('./assets/themes/snowy/bg-light.jpg');
      ::v-deep .theme--light.v-sheet {
        background: #ffffffd9;
        .theme--light.v-sheet {
          background: #ffffffd9 !important;
        }

        .mood-select {
          .v-input__slot {
            background: #ffffffc4 !important;
          }
        }

        pre {
          background: #000000b5;

          code {
            box-shadow: none;
          }
        }
      }
    }
  }

  &.logbook-theme-alpine {
    background-attachment: fixed !important;
    background-size: cover !important;
    background-position: center !important;

    &.theme--dark {
      background: url('./assets/themes/alpine/bg-dark.jpg');
      ::v-deep .theme--dark.v-sheet {
        background: #424242bd;
        .theme--dark.v-sheet {
          background: #424242c4 !important;
        }

        .mood-select {
          .v-input__slot {
            background: #42424269 !important;
          }
        }

        pre {
          background: #0000004f;

          code {
            box-shadow: none;
          }
        }
      }
    }
    &.theme--light {
      background: url('./assets/themes/alpine/bg-light.jpg');
      ::v-deep .theme--light.v-sheet {
        background: #ffffffd9;
        .theme--light.v-sheet {
          background: #ffffffd9 !important;
        }
        .mood-select {
          .v-input__slot {
            background: #ffffffc4 !important;
          }
        }

        pre {
          background: #000000b5;

          code {
            box-shadow: none;
          }
        }
      }
    }
  }

  &.logbook-theme-urban {
    background-attachment: fixed !important;
    background-size: cover !important;
    background-position: center !important;

    &.theme--dark {
      background: url('./assets/themes/urban/bg-dark.jpg');
      ::v-deep .theme--dark.v-sheet {
        background: #424242bd;
        .theme--dark.v-sheet {
          background: #424242c4 !important;
        }

        .mood-select {
          .v-input__slot {
            background: #42424269 !important;
          }
        }

        pre {
          background: #0000004f;

          code {
            box-shadow: none;
          }
        }
      }
    }
    &.theme--light {
      background: url('./assets/themes/urban/bg-light.jpg');
      ::v-deep .theme--light.v-sheet {
        background: #ffffffd9;
        .theme--light.v-sheet {
          background: #ffffffd9 !important;
        }
        .mood-select {
          .v-input__slot {
            background: #ffffffc4 !important;
          }
        }

        pre {
          background: #000000b5;

          code {
            box-shadow: none;
          }
        }
      }
    }
  }

  &.logbook-theme-space {
    background-attachment: fixed !important;
    background-size: cover !important;
    background-position: center !important;

    &.theme--dark {
      background: url('./assets/themes/space/bg-dark.jpg');
      ::v-deep .theme--dark.v-sheet {
        background: #424242bd;
        .theme--dark.v-sheet {
          background: #424242c4 !important;
        }

        .mood-select {
          .v-input__slot {
            background: #42424269 !important;
          }
        }

        pre {
          background: #0000004f;

          code {
            box-shadow: none;
          }
        }
      }
    }
    &.theme--light {
      background: url('./assets/themes/space/bg-light.jpg');
      ::v-deep .theme--light.v-sheet {
        background: #ffffffd9;
        .theme--light.v-sheet {
          background: #ffffffd9 !important;
        }
        .mood-select {
          .v-input__slot {
            background: #ffffffc4 !important;
          }
        }

        pre {
          background: #000000b5;

          code {
            box-shadow: none;
          }
        }
      }
    }
  }
}
</style>
